// frontend/src/pages/PortalPricing.jsx (Phase 19)
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { usePortalAuth } from "../context/PortalAuthContext";
import { portalApi } from "../services/portalApi";
import "../styles/portal.css";

// Grille marketing (les prix réels vivent dans Stripe ; `key` = nom du tier
// envoyé à /billing/checkout qui le mappe sur stripe_price_id en base).
const TIERS = [
  { key: "free", name: "Free", price: "0€", features: ["1 req/s", "1 000 req/mois", "Données brutes"] },
  { key: "standard", name: "Standard", price: "—", features: ["10 req/s", "1M req/mois", "Données brutes"] },
  { key: "premium", name: "Premium", featured: true, price: "—",
    features: ["50 req/s", "5M req/mois", "Accès Notaire (preuve crypto)"] },
  { key: "enterprise", name: "Enterprise", price: "Sur devis",
    features: ["200 req/s", "Quota illimité", "Accès Notaire", "Support dédié"] },
];

export default function PortalPricing() {
  const { authenticated, client } = usePortalAuth();
  const [busy, setBusy] = useState("");
  const [error, setError] = useState("");

  const subscribe = async (tier) => {
    setError("");
    setBusy(tier);
    const { ok, data } = await portalApi("/api/portal/billing/checkout", {
      method: "POST", body: { tier },
    });
    setBusy("");
    if (ok && data.checkout_url) window.location.href = data.checkout_url;
    else setError(data?.error || "Impossible de démarrer le paiement.");
  };

  const manage = async () => {
    setError("");
    setBusy("manage");
    const { ok, data } = await portalApi("/api/portal/billing/portal", { method: "POST" });
    setBusy("");
    if (ok && data.portal_url) window.location.href = data.portal_url;
    else setError(data?.error || "Aucun abonnement à gérer.");
  };

  return (
    <div className="pt-root">
      <h1 className="pt-title">Nos offres</h1>
      <p className="pt-subtitle">Choisis la puissance qu'il te faut.</p>

      <div className="pt-grid">
        {TIERS.map((t) => (
          <div key={t.key} className={`pt-plan ${t.featured ? "pt-plan--featured" : ""}`}>
            <div className="pt-plan__name">{t.name}</div>
            <div className="pt-plan__price">
              {t.price}{/€$/.test(t.price) && <span> /mois</span>}
            </div>
            <ul className="pt-feat">
              {t.features.map((f, i) => <li key={i}>{f}</li>)}
            </ul>
            {t.key !== "free" && t.key !== "enterprise" && (
              <button className="pt-btn pt-btn--primary" disabled={true} style={{ opacity: 0.6, cursor: "not-allowed", textAlign: "center" }}>
                Bientôt disponible
              </button>
            )}
          </div>
        ))}
      </div>

      {authenticated && client?.has_notary_access && (
        <button className="pt-btn pt-btn--ghost" style={{ maxWidth: 420, marginTop: 24 }}
                disabled={busy === "manage"} onClick={manage}>
          Gérer mon abonnement
        </button>
      )}

      <div className="pt-error">{error}</div>
      <div className="pt-foot">
        {authenticated
          ? <Link className="pt-link" to="/portal/dashboard">← Retour au dashboard</Link>
          : <Link className="pt-link" to="/portal/login">Se connecter</Link>}
      </div>
    </div>
  );
}
